import * as types from "@/constants/types";
import Immutable from "immutable";
import _ from "lodash";

const INITIAL_STATE = {
  companies: [],
  search: "",
  clients: { data: [] },
  clientsLoading: false,
  clientType: "all",
  clientSelected: null,
  allMessages: 0,
  myMessages: 0,
  messages: { data: [] },
  messagesLoading: false,
  users: [],
  apps: [],
  services: [],
  properties: [],
  comments: [],
};

export default (state = INITIAL_STATE, action) => {
  var newState, $var;
  switch (action.type) {
    case types.SET_APP:
      newState = Immutable.fromJS(state).setIn(action.path, action.value);
      return newState.toJS();
    case types.SET_APP_BY_PARAM:
      newState = Immutable.fromJS(state);
      if (action.param.length !== 2) return newState.toJS();
      const [name, value] = action.param;
      $var = newState.getIn(action.path).toJS();
      $var = _.findIndex($var, { [name]: value });
      if ($var === -1) return newState.toJS();
      Object.keys(action.value).forEach((key) => {
        newState = newState.setIn(
          [...action.path, $var, key],
          action.value[key]
        );
      });
      return newState.toJS();
    case types.SET_APPS:
      newState = Immutable.fromJS(state);
      if (action.arr && action.arr.length !== 0) {
        action.arr.forEach((values) => {
          newState = newState.setIn(values.path, values.value);
        });
      }
      return newState.toJS();
    case types.PUSH_APP:
      newState = Immutable.fromJS(state).updateIn(action.path, (data) =>
        data.push(action.value)
      );
      return newState.toJS();
    case types.UNSHIFT_APP:
      newState = Immutable.fromJS(state).updateIn(action.path, (data) =>
        data.unshift(action.value)
      );
      return newState.toJS();
    case types.REMOVE_APP_BY_PARAM:
      newState = Immutable.fromJS(state);
      $var = newState
        .getIn(action.path)
        .filter((o) => o.get(action.key) !== action.value);
      return newState.setIn(action.path, $var).toJS();
    default:
      return state;
  }
};
